import React from 'react'

import { HeroScene } from "./HeroScene";
import { Assignments } from '../Assignments/Assignments'
import { CodeAlong } from '../CodeAlong/CodeAlong'
import { Hours } from '../Hours/Hours'
import { Labs } from '../Labs and Sections/Labs'
import { Lectures } from '../Lectures/Lectures'
import { Resources } from '../Resources/Resources'
import { SRC } from '../SRC/SRC'
import { Staff } from '../Staff/Staff'

export class Welcome extends React.Component{

    render(){
        return(
                <>
                    <HeroScene />
                    <Assignments static={true}/>
                    <Lectures static={true}/>
                    <Labs static={true}/>
                    <CodeAlong static={true}/>
                    <Hours static={true}/>
                    <SRC static={true} />
                    <Resources static={true}/>
                    <Staff static={true}/>
                </>
        )
    }

}